export const PARTNER_META_KEY = 'partner-metadata';
export const PRICING_META_KEY = 'pricing-page';
export const ACCENTURE_SLUG = 'partner-accenture';

export const ACCENTURE_EAS_DATA = {
  prod_itr_af_basic: {
    listPrice: 5396,
    discountedPrice: 1349,
    discount: '(-75%)',
  },
  prod_itr_af_premium: {
    listPrice: 8996,
    discountedPrice: 2249,
    discount: '(-75%)',
  },
  prod_itr_af_black: {
    listPrice: 14396,
    discountedPrice: 3599,
    discount: '(-75%)',
  },
};

const ACCENTURE_PRICING_DATA = {
  selfITRPlansData: [
    {
      planDetails: {
        price: 599,
        name: 'Salary Income Plan - Plan A',
        listingId: 'prod_self_itr_30',
        planId: 'prod_self_itr_30',
        seoSlug: 'prod_self_itr_30',
        shortDescription: 'Salary Income Plan - Plan A',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [
          {
            id: 1917,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Salary Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1918,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Interest Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1920,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Freelancing Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1921,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Dividend Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1922,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Single or Multiple Form16</span></p>',
            serviceImage: '',
          },
        ],
        whenRequired: [
          {
            id: 1904,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Salary Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1905,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Interest Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1906,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Freelancing Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1907,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Dividend Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1908,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Single or Multiple Form16</span></p>',
            serviceImage: '',
          },
        ],
        offerPricing: {
          originalPrice: 599,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 706.82,
          listPrice: 599,
          discountedPrice: 150,
          tax: 26.96,
          totalAmount: 176.71,
          roundedAmount: 177,
          roundedTax: 27,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592643,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 1077,
        name: 'Salary Income Plan - Plan B',
        listingId: 'prod_self_itr_31',
        planId: 'prod_self_itr_31',
        seoSlug: 'prod_self_itr_31',
        shortDescription: 'Salary Income Plan - Plan B',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 1077,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 1270.86,
          listPrice: 1077,
          discountedPrice: 269.25,
          tax: 48.46,
          totalAmount: 317.71,
          roundedAmount: 318,
          roundedTax: 49,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592661,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 2276,
        name: 'Salary Income Plan - Plan C',
        listingId: 'prod_self_itr_32',
        planId: 'prod_self_itr_32',
        seoSlug: 'prod_self_itr_32',
        shortDescription: 'Salary Income Plan - Plan C',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 2276,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 2685.68,
          listPrice: 2276,
          discountedPrice: 569,
          tax: 102.42,
          totalAmount: 671.42,
          roundedAmount: 672,
          roundedTax: 103,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592660,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 3356,
        name: 'Salary Income Plan - Plan D',
        listingId: 'prod_self_itr_33',
        planId: 'prod_self_itr_33',
        seoSlug: 'prod_self_itr_33',
        shortDescription: 'Salary Income Plan - Plan D',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 3356,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 3960.08,
          listPrice: 3356,
          discountedPrice: 839,
          tax: 151.02,
          totalAmount: 990.02,
          roundedAmount: 990,
          roundedTax: 151,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592660,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 4196,
        name: 'Salary Income Plan - Plan E',
        listingId: 'prod_self_itr_15',
        planId: 'prod_self_itr_15',
        seoSlug: 'prod_self_itr_15',
        shortDescription: 'Salary Income Plan - Plan E',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 4196,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 4951.28,
          listPrice: 4196,
          discountedPrice: 1049,
          tax: 188.82,
          totalAmount: 1237.82,
          roundedAmount: 1238,
          roundedTax: 189,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592659,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 1496,
        name: 'Capital Gains or Rental Income Plan - Plan A',
        listingId: 'prod_self_itr_34',
        planId: 'prod_self_itr_34',
        seoSlug: 'prod_self_itr_34',
        shortDescription: 'Capital Gains or Rental Income Plan - Plan A',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [
          {
            id: 1917,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Salary Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1918,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Interest Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1920,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Freelancing Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1921,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Dividend Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1923,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Stocks &amp; Mutual Funds, RSU/ESOPs</span></p>',
            serviceImage: '',
          },
          {
            id: 1924,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">RSU/ESOPs</span></p>',
            serviceImage: '',
          },
          {
            id: 1925,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Futures &amp; Options, Business</span></p>',
            serviceImage: '',
          },
          {
            id: 1926,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Rental Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1927,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Online Gaming</span></p>',
            serviceImage: '',
          },
          {
            id: 1922,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Single or Multiple Form16</span></p>',
            serviceImage: '',
          },
        ],
        whenRequired: [
          {
            id: 1909,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Stocks &amp; Mutual Funds, RSU/ESOPs</span></p>',
            serviceImage: '',
          },
          {
            id: 1910,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Futures &amp; Options, Business</span></p>',
            serviceImage: '',
          },
          {
            id: 1911,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Rental Income</span></p>',
            serviceImage: '',
          },
          {
            id: 1912,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Online Gaming</span></p>',
            serviceImage: '',
          },
          {
            id: 1915,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Everything in Salary Income Plan</span></p>',
            serviceImage: '',
          },
        ],
        offerPricing: {
          originalPrice: 1496,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 1765.28,
          listPrice: 1496,
          discountedPrice: 374,
          tax: 67.32,
          totalAmount: 441.32,
          roundedAmount: 441,
          roundedTax: 67,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592641,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 2396,
        name: 'Capital Gains or Rental Income Plan - Plan B',
        listingId: 'prod_self_itr_35',
        planId: 'prod_self_itr_35',
        seoSlug: 'prod_self_itr_35',
        shortDescription: 'Capital Gains or Rental Income Plan - Plan B',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 2396,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 2827.28,
          listPrice: 2396,
          discountedPrice: 599,
          tax: 107.82,
          totalAmount: 706.82,
          roundedAmount: 707,
          roundedTax: 108,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592659,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 3596,
        name: 'Capital Gains or Rental Income Plan - Plan C',
        listingId: 'prod_self_itr_36',
        planId: 'prod_self_itr_36',
        seoSlug: 'prod_self_itr_36',
        shortDescription: 'Capital Gains or Rental Income Plan - Plan C',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 3596,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 4243.28,
          listPrice: 3596,
          discountedPrice: 899,
          tax: 161.82,
          totalAmount: 1060.82,
          roundedAmount: 1061,
          roundedTax: 162,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592661,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 5156,
        name: 'Capital Gains or Rental Income Plan - Plan D',
        listingId: 'prod_self_itr_16',
        planId: 'prod_self_itr_16',
        seoSlug: 'prod_self_itr_16',
        shortDescription: 'Capital Gains or Rental Income Plan - Plan D',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 5156,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 6084.08,
          listPrice: 5156,
          discountedPrice: 1289,
          tax: 232.02,
          totalAmount: 1521.02,
          roundedAmount: 1521,
          roundedTax: 232,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592660,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 5996,
        name: 'Capital Gains or Rental Income Plan - Plan E',
        listingId: 'prod_self_itr_17',
        planId: 'prod_self_itr_17',
        seoSlug: 'prod_self_itr_17',
        shortDescription: 'Capital Gains or Rental Income Plan - Plan E',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 5996,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 7075.28,
          listPrice: 5996,
          discountedPrice: 1499,
          tax: 269.82,
          totalAmount: 1768.82,
          roundedAmount: 1769,
          roundedTax: 270,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592660,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 4196,
        name: 'NRI or Foreign Income Plan - Plan A',
        listingId: 'prod_self_itr_37',
        planId: 'prod_self_itr_37',
        seoSlug: 'prod_self_itr_37',
        shortDescription: 'NRI or Foreign Income Plan - Plan A',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [
          {
            id: 1929,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">NRI Taxation</span></p>',
            serviceImage: '',
          },
          {
            id: 1930,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Schedule FSI</span></p>',
            serviceImage: '',
          },
          {
            id: 1931,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Schedule TR</span></p>',
            serviceImage: '',
          },
          {
            id: 1932,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Foreign Stocks</span></p>',
            serviceImage: '',
          },
          {
            id: 1933,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">All income &amp; Services in Other Plans</span></p>',
            serviceImage: '',
          },
        ],
        whenRequired: [
          {
            id: 1853,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">NRI Taxation</span></p>',
            serviceImage: '',
          },
          {
            id: 1934,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Schedule FSI</span></p>',
            serviceImage: '',
          },
          {
            id: 1913,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Schedule TR</span></p>',
            serviceImage: '',
          },
          {
            id: 1914,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Foreign Stocks</span></p>',
            serviceImage: '',
          },
          {
            id: 1916,
            richText:
              '<p><span style="color: rgb(0, 0, 0);">Everything in Other Plans</span></p>',
            serviceImage: '',
          },
        ],
        offerPricing: {
          originalPrice: 4196,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 4951.28,
          listPrice: 4196,
          discountedPrice: 1049,
          tax: 188.82,
          totalAmount: 1237.82,
          roundedAmount: 1238,
          roundedTax: 189,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592647,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 5036,
        name: 'NRI or Foreign Income Plan - Plan B',
        listingId: 'prod_self_itr_38',
        planId: 'prod_self_itr_38',
        seoSlug: 'prod_self_itr_38',
        shortDescription: 'NRI or Foreign Income Plan - Plan B',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 5036,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 5942.48,
          listPrice: 5036,
          discountedPrice: 1259,
          tax: 226.62,
          totalAmount: 1485.62,
          roundedAmount: 1486,
          roundedTax: 227,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592659,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
    {
      planDetails: {
        price: 6596,
        name: 'NRI or Foreign Income Plan - Plan C',
        listingId: 'prod_self_itr_18',
        planId: 'prod_self_itr_18',
        seoSlug: 'prod_self_itr_18',
        shortDescription: 'NRI or Foreign Income Plan - Plan C',
        productServiceType: 'ITR-SCO-GENERAL',
        servicesIncluded: [],
        whenRequired: [],
        offerPricing: {
          originalPrice: 6596,
          discountPercentage: 0,
        },
        pricing: {
          listPriceWithGST: 7783.28,
          listPrice: 6596,
          discountedPrice: 1649,
          tax: 296.82,
          totalAmount: 1945.82,
          roundedAmount: 1946,
          roundedTax: 297,
        },
      },
      coupon: {
        code: 'CTACCENTX',
        discountValue: 75,
        availableCount: 97215,
        consumedCount: 9746,
        discountType: 'PERCENTAGE',
        status: 'ACTIVE',
        description: 'Get Exclsuive Discount-Valid for 24hr',
        expiredAt: '2026-12-31T18:30:00.000+00:00',
        personalizedCoupon: false,
        updatedAt: '2025-08-07T14:27:52.000+00:00',
        milliSecondsLeftToExpire: 44164592660,
        extraDiscountAllowed: false,
      },
      partnerSlug: 'partner-accenture',
    },
  ],
};

export default ACCENTURE_PRICING_DATA;
